exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".userBuddy-5f35e{position:relative;margin-top:20px}.userBuddy-5f35e:hover .editIcon-cf761{visibility:visible;cursor:pointer}.editIcon-cf761{position:absolute;right:0;top:5px;visibility:hidden;font-size:18px;color:#1677ff}", ""]);

// Exports
exports.locals = {
	"userBuddy": "userBuddy-5f35e",
	"editIcon": "editIcon-cf761"
};